import { Routes } from '@angular/router';
import FrontendComponent from './_layout/frontend.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { WorkshopCatalogueDetailComponent } from './organizations/workshop-catalogue-detail/workshop-catalogue-detail.component';
import { SkillzTeamComponent } from './skillz-team/skillz-team.component';
import { embed, redirect, signupRedirect } from './redirect/redirect';
import { resolveWorkshop } from '../api/workshop/workshop.resolver';
import { documentRoutes } from './document.routes';

const routes: Routes = [
  {
    path: '',
    component: FrontendComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./home/home.component.js'),
      },
      {
        path: $localize`:@@/faq:faq`,
        loadComponent: () => import('./faq/faq.component.js'),
      },
      {
        path: $localize`:@@/skillz-team:skillz-team`,
        component: SkillzTeamComponent,
      },
      {
        path: $localize`:@@/contact-us:contact-us`,
        loadComponent: () => import('./contact-us/contact-us.component'),
      },
      {
        path: $localize`:@@/become-monitor:become-monitor`,
        loadComponent: () =>
          import('./become-monitor/become-monitor.component'),
      },
      {
        path: $localize`:@@/staff-invite:staff-invite`,
        canActivate: [AuthGuard],
        loadComponent: () => import('./staff-invite/staff-invite.component'),
      },
      {
        path: $localize`:@@/courses:courses`,
        loadChildren: () => import('./courses/courses.routes'),
      },
      {
        path: $localize`:@@/after-school/slug:after-school/:slug`,
        component: WorkshopCatalogueDetailComponent,
        resolve: {
          workshop: resolveWorkshop,
        },
      },
      {
        path: $localize`:@@/after-school:after-school`,
        loadChildren: () => import('./organizations/after-school.routes.js'),
      },
      {
        path: $localize`:@@/workshops:workshops`,
        loadChildren: () => import('./organizations/workshops.routes.js'),
      },
      {
        path: $localize`:@@/custom-camps:custom-camps`,
        loadChildren: () => import('./organizations/custom-camps.routes.js'),
      },
      {
        path: $localize`:@@/cart:cart`,
        loadChildren: () => import('./shopping-cart/shopping-cart.routes.js'),
      },
      {
        path: $localize`:@@/checkout/result:checkout/result`,
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./checkout-result/checkout-result.component.js'),
      },
      ...documentRoutes,
    ],
  },
  {
    path: $localize`:@@/profile:profile`,
    canActivate: [AuthGuard],
    loadChildren: () => import('./customer-profile/customer-profile.routes.js'),
  },
  {
    path: 'redirect',
    loadComponent: () => import('./redirect/redirect.component'),
  },
  {
    path: $localize`:@@/signup:signup`,
    redirectTo: signupRedirect(),
  },
  {
    path: $localize`:@@/report:report`,
    redirectTo: redirect(
      'https://airtable.com/appkVrpYmezptqH4L/pagUH4rkFUFkKkGUX/form',
    ),
  },
  embed(
    $localize`:@@/newsletter:newsletter`,
    'https://s326y.mjt.lu/wgt/s326y/xkis/form?c=b58cea86',
    {
      scripts: ['https://app.mailjet.com/pas-nc-embedded-v1.js'],
    },
  ),
];

export default routes;
